import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlService } from 'src/environments/urlService';
import { ManagementEntity } from '../dto/ManagementEntity';
import { Observable } from 'rxjs';
import { IS_SPINNER_ACTIVE } from 'src/app/util/interceptors';
import { ManagementEntityDataDTO } from '../dto/ManagementEntityDataDTO';

@Injectable({
  providedIn: 'root',
})

export class ManagementEntityService {
  private readonly url;
  private readonly endpoint = 'fund-info';

  constructor(private http: HttpClient,
    private urlService: UrlService,
  ) {
    this.url = this.urlService.getFmsUrl() + 'management-companies/';
  }

  create(fund: ManagementEntity): Promise<ManagementEntity> {
    return this.http.post<ManagementEntity>(this.url, fund,
      { withCredentials: true, responseType: 'json' })
      .toPromise();
  }

  update(fund: ManagementEntity): Promise<ManagementEntity> {
    return this.http.put<ManagementEntity>(this.url, fund,
      { withCredentials: true, responseType: 'json' })
      .toPromise();
  }

  get(orgUuid: string): Promise<ManagementEntity[]> {
    return this.http.get<ManagementEntity[]>(this.url + 'by-org',
      {
        params: { orgUuid }
        , withCredentials: true, responseType: 'json',
      })
      .toPromise();
  }

  delete(id: number): Promise<ManagementEntity[]> {
    return this.http.delete<ManagementEntity[]>(this.url,
      {
        params: { id },
        context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
        withCredentials: true, responseType: 'json',
      })
      .toPromise();
  }

  getPeriods(uuid: string): Observable<Date[]> {
    return this.http.get<Date[]>(this.url + 'periods',
      {
        params: { uuid }
        , withCredentials: true, responseType: 'json',
      });
  }

  createPeriod(period: Date, uuid: string): Observable<Date> {
    return this.http.post<Date>(this.url + 'create-period', period, {
      params: { uuid },
      withCredentials: true,
      responseType: 'json',
    });
  }

  deletePeriod(period: Date, uuid: string): Observable<void> {
    const entityDataDTO = new ManagementEntityDataDTO(uuid, period);
    return this.http.post<void>(this.url + 'delete-period', entityDataDTO, {
      withCredentials: true,
      responseType: 'json',
    });
  }

}
